import React, { useState } from 'react';
import { Tabs } from '@forgeglobal/design-framework';
import TabContent from '@tcs/common/components/atoms/TabContent';
import Header from '@tcs/client-portal-common/components/organisms/Header';
import ProfileSecurity from '@tcs/client-portal-common/components/templates/ProfileSecurity';
import PasswordSuccessBanner from '@tcs/client-portal-common/components/molecules/PasswordSuccessBanner';
import RepresentativeInfo from '@tcs/client-portal-common/components/templates/RepresentativeInfo';
import { useGetQuestion } from '@tcs/client-portal-common/hooks/auth';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import useRepresentative from '@tcs/client-portal-common/hooks/useRepresentative';
import Spinner from '@tcs/common/components/atoms/Spinner';
import { Route } from 'react-router';

const Profile = () => {
  const { data: securityQuestion, loading: loadingQuestion } = useGetQuestion();
  const [showMessage, setShowMessage] = useState('');
  const [question, setQuestion] = useState('');
  const {
    claims: { clientPortalIdentity },
  } = useSession();
  const { loading: loadingRepresentative, data: representative } =
    useRepresentative(clientPortalIdentity);

  if (loadingRepresentative) {
    return <Spinner />;
  }

  return (
    <>
      <PasswordSuccessBanner
        message={showMessage}
        dismissMessage={() => setShowMessage('')}
      />
      <Header
        pageTitle="Profile"
        tabs={() => (
          <Tabs>
            <Route
              path="*"
              element={
                <TabContent
                  label="Personal Info"
                  data-test-id="profile-personal-info-tab">
                  <RepresentativeInfo profile={representative} />
                </TabContent>
              }
            />
            <Route
              path="/security"
              element={
                <TabContent
                  label="Security"
                  data-test-id="profile-security-tab">
                  <ProfileSecurity
                    question={question || securityQuestion?.text}
                    setQuestion={setQuestion}
                    showMessage={setShowMessage}
                    loading={loadingQuestion}
                  />
                </TabContent>
              }
            />
          </Tabs>
        )}
      />
    </>
  );
};

export default Profile;
